import { render, staticRenderFns } from "./ListAccountBank.vue?vue&type=template&id=ffb25bc2"
import script from "./ListAccountBank.vue?vue&type=script&lang=js"
export * from "./ListAccountBank.vue?vue&type=script&lang=js"
import style0 from "./ListAccountBank.vue?vue&type=style&index=0&id=ffb25bc2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports